import React, { useRef, useState } from "react";
import { Button, Grid, TextField, CircularProgress } from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";

const ViewMsisdn = () => {
  const [data, setData] = useState<any>(null);
  const [msisdn, setmsisdn] = useState("");

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);

  const columnDefs: ColDef[] = [
    {
      field: "ID",
      headerName: "ID",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "MSISDN",
      headerName: "Msisdn",
      filter: true,
      resizable: true,
      sortable: true,
    },
  ];
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };
  const handleSubmit = async () => {
    setData(null);
    toast.dismiss();

    const items = msisdn.split(",").map((item) => item.trim());
    // Filter out empty values
    const filteredItems = items.filter((item) => item !== "");
    if (filteredItems.length === 0) {
      toast.error("Please enter valid values");
    } else {
      setAction(true);
      requestMsisdn();
    }
  };

  const requestMsisdn = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/ViewMsisdn?PaymentID=${msisdn.trim()}`)
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data.length == 0) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">View Msisdn</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="Enter Id"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
              />
            </Grid>

            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleSubmit}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            rowData={data}
            domLayout="autoHeight"
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default ViewMsisdn;
